import { apiUpload, normalizeAssetUrlForStorage } from '../utils/api';

export const uploadSessionMaterialFile = (file) =>
  apiUpload('/api/v1/files/session-material', file);

export const uploadMaterialsForSessions = async (sessions, sessionMaterials) => {
  const uploadedBySession = {};

  for (const session of sessions) {
    const entry = sessionMaterials[session.id];
    if (!entry?.files?.length) continue;

    uploadedBySession[session.id] = [];
    for (const item of entry.files) {
      const result = await uploadSessionMaterialFile(item.file);
      uploadedBySession[session.id].push({
        url: normalizeAssetUrlForStorage(result.url),
        filename: result.filename || item.name,
        mimetype: result.mimetype || item.type,
        size: result.size || item.size,
      });
    }
  }

  return uploadedBySession;
};
